import React from "react";
import {
  ELECTRONIC_DOCUMENT_STATUS,
  INTERNAL_DOCUMENT_INCOMING_STATUS,
  MISSION_STATUS,
  NOTIFICATION_STATUS,
  POLICY_STATUS,
  PROPOSAL_STATUS,
  SALARY_STATUS,
  TYPE_STATUS,
  WORK_STATUS,
} from "../../utils/constants";

export const StatusTag = (typePage, status, isText = false) => {
  let text = "Không rõ";
  let style = null;

  if (typePage === TYPE_STATUS.ELECTRONIC_DOCUMENT) {
    if (status === ELECTRONIC_DOCUMENT_STATUS.PENDING) {
      style = "text-orange-500";
      text = "Chưa xử lý";
    }
    if (status === ELECTRONIC_DOCUMENT_STATUS.VT_APPROVAL) {
      style = "text-blue-500";
      text = "Văn thư đã duyệt";
    }
    if (status === ELECTRONIC_DOCUMENT_STATUS.LEAD_APPROVAL) {
      style = "geekBlue";
      text = "Lãnh đạo đã duyệt";
    }
    if (status === ELECTRONIC_DOCUMENT_STATUS.REGIS_NUMBER) {
      style = "text-purple-500";
      text = "Đã cấp số";
    }
    if (status === ELECTRONIC_DOCUMENT_STATUS.READY) {
      style = "text-cyan-500";
      text = "Chờ phát hành";
    }
    if (status === ELECTRONIC_DOCUMENT_STATUS.RELEASE) {
      style = "text-green-500";
      text = "Đã phát hành";
    }
  }
  if (typePage.typePage === TYPE_STATUS.PROPOSAL) {
    if (typePage.status === PROPOSAL_STATUS.PENDING) {
      style = "text-orange-600 bg-white";
      text = "Chờ phê duyệt";
    }
    if (typePage.status === PROPOSAL_STATUS.APPROVAL) {
      style = "text-green-600 bg-white";
      text = "Đã phê duyệt";
    }
    if (typePage.status === PROPOSAL_STATUS.REJECT) {
      style = "text-red-600 bg-white";
      text = "Từ chối";
    }
    if (typePage.status === PROPOSAL_STATUS.CREATED) {
      style = "text-green-600 bg-white";
      text = "Đã tạo";
    }
    if (typePage.status === PROPOSAL_STATUS.WAITING) {
      style = "text-amber-600 bg-white";
      text = "Chờ duyệt";
    }
  }
  if (typePage === TYPE_STATUS.POLICY) {
    if (status === POLICY_STATUS.PENDING) {
      style = "text-blue-500";
      text = "Đang xử lý";
    }
    if (status === POLICY_STATUS.COMPLETE) {
      style = "text-green-500";
      text = "Hoàn thành";
    }
  }
  if (typePage === TYPE_STATUS.CONSULT) {
    if (status === POLICY_STATUS.PENDING) {
      style = "text-blue-500";
      text = "Đang cho ý kiến";
    }
    if (status === POLICY_STATUS.COMPLETE) {
      style = "text-green-500";
      text = "Hoàn thành";
    }
  }
  if (typePage === TYPE_STATUS.WORK) {
    if (status === WORK_STATUS.INTERNAL) {
      style = "text-cyan-500";
      text = "Nội bộ trong Ban";
    }
    if (status === WORK_STATUS.CONSULT) {
      style = "text-orange-500";
      text = "Xin ý kiến các Ban";
    }
    if (status === WORK_STATUS.POLICY) {
      style = "geekBlue";
      text = "Xin chủ trương";
    }
    if (status === WORK_STATUS.DOCUMENT) {
      style = "text-blue-500";
      text = "Xử lý văn bản";
    }
    if (status === WORK_STATUS.ELECTRONIC) {
      style = "magenta";
      text = "Trình ký văn bản";
    }
    if (status === WORK_STATUS.DEPLOY) {
      style = "volcano";
      text = "Triển khai nhiệm vụ";
    }
    if (status === WORK_STATUS.OTHER) {
      style = "magenta";
      text = "Loại khác";
    }
    if (status === WORK_STATUS.COMPLETE) {
      style = "text-green-500";
      text = "Hoàn thành";
    }
    if (status === WORK_STATUS.PENDING) {
      style = "text-purple-500";
      text = "Đang thực hiện";
    }
  }
  if (typePage === TYPE_STATUS.NOTIFICATION) {
    if (status === NOTIFICATION_STATUS.OUTGOING) {
      style = "text-green-500";
      text = "Văn bản nội bộ đi";
    }
    if (status === NOTIFICATION_STATUS.INCOMING) {
      style = "text-green-500";
      text = "Văn bản nội bộ đến";
    }
    if (status === NOTIFICATION_STATUS.WORK) {
      style = "text-orange-500";
      text = "Công việc";
    }
    if (status === NOTIFICATION_STATUS.TASK) {
      style = "text-purple-500";
      text = "Nhiệm vụ";
    }
    if (
      [
        NOTIFICATION_STATUS.VEHICLE,
        NOTIFICATION_STATUS.LEAVE,
        NOTIFICATION_STATUS.LEAVE_ANNUAL,
        NOTIFICATION_STATUS.LEAVE_NO_SALARY,
        NOTIFICATION_STATUS.BUSINESS_TRIP,
        NOTIFICATION_STATUS.EVALUATE_MEMBER,
        NOTIFICATION_STATUS.EVALUATE_LEADER,
        NOTIFICATION_STATUS.TIMEKEEPER,
        NOTIFICATION_STATUS.STATIONERY,
        NOTIFICATION_STATUS.MEETING,
      ].includes(status)
    ) {
      style = "text-cyan-500";
      text = "Hành chính";
    }
    if ([NOTIFICATION_STATUS.PROPOSAL_SALARY].includes(status)) {
      style = "text-cyan-500";
      text = "Duyệt lương";
    }
    if (status === NOTIFICATION_STATUS.CONSULT) {
      style = "#597ef7";
      text = "Xin ý kiến";
    }
    if (status === NOTIFICATION_STATUS.POLICY) {
      style = "#69c0ff";
      text = "Xin chủ chương";
    }
    if (status === NOTIFICATION_STATUS.VBLT_DI) {
      style = "#69c0ff";
      text = "Văn bản liên thông đi";
    }
    if (status === NOTIFICATION_STATUS.VBLT_DEN) {
      style = "#69c0ff";
      text = "Văn bản liên thông đến";
    }
    if (status === NOTIFICATION_STATUS.WORK_SCHEDULE) {
      style = "#d03bff";
      text = "Lịch cơ quan";
    }
    if (status === NOTIFICATION_STATUS.GENERAL) {
      style = "text-blue-500";
      text = "Thông báo chung";
    }
    if (
      status === NOTIFICATION_STATUS.INTERNAL_MESSAGE_INCOMING ||
      status === NOTIFICATION_STATUS.INTERNAL_MESSAGE_OUTGOING ||
      status === NOTIFICATION_STATUS.INTERNAL_MESSAGE_INCOMING_REPLY ||
      status === NOTIFICATION_STATUS.INTERNAL_MESSAGE_OUTGOING_REPLY
    ) {
      style = "text-blue-500";
      text = "Tin nhắn";
    }
  }
  if (typePage === TYPE_STATUS.INTERNAL_DOCUMENT_INCOMING) {
    if (status === INTERNAL_DOCUMENT_INCOMING_STATUS.PENDING) {
      style = "bg-lightYellow border-yellow text-[#615207]";
      text = "Chờ xử lý";
    }
    if (status === INTERNAL_DOCUMENT_INCOMING_STATUS.INPROGRESS) {
      style = "bg-lightBlue border-primary text-[#161616]";
      text = "Đã bút phê";
    }
    if (status === INTERNAL_DOCUMENT_INCOMING_STATUS.COMPLETE) {
      style = "text-green-500";
      text = "Hoàn thành";
    }
  }
  if (typePage === TYPE_STATUS.MISSION) {
    if (status === MISSION_STATUS.PENDING) {
      style = "text-orange-500";
      text = "Chưa thực hiện";
    }
    if (status === MISSION_STATUS.INPROGRESS) {
      style = "text-blue-500";
      text = "Đang thực hiện";
    }
    if (status === MISSION_STATUS.COMPLETE) {
      style = "text-green-500";
      text = "Hoàn thành";
    }
  }

  if (typePage === TYPE_STATUS.SALARY) {
    if (status === SALARY_STATUS.PENDING) {
      style = "text-orange-500";
      text = "Chờ phê duyệt";
    }
    if (status === SALARY_STATUS.TRUONG_BAN_APPROVED) {
      style = "text-blue-500";
      text = "Trưởng ban đã duyệt";
    }
    if (status === SALARY_STATUS.TGD_APPROVED) {
      style = "text-green-500";
      text = "Tổng giám đốc đã duyệt";
    }
  }

  if (isText) {
    return text;
  }

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {style && (
        <div
          className={` border-[1px]  px-[10px] rounded  font-semibold text-[10px] leading-6 inline-block ${style}`}
        >
          {text}
        </div>
      )}
    </div>
  );
};
